export default __webpack_public_path__ + "images/afpocket_dark.c99e7695690e89556123a478d60067e6.png";